import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import CityAudios from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/city-audios'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'city_audios_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'city_audios_list',
          meta: {
            featureFlag: FEATURE_FLAGS.CITY_AUDIOS,
            permissions: [...ROLES],
          },
          component: CityAudios,
        },
      ],
    },
  ],
};
